module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/Eraser-7c6a907e3e19dfefc7ccefe2968fbc66.svg";